<template>
  <v-autocomplete
    :filter="searchQuery"
    hide-no-data
    solo
    :value="value"
    @change="(val) => $emit('change', val)"
    v-bind="{ ...$props, ...$attrs }"
  >
    <template v-for="(_, name) in $scopedSlots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps || {}" />
    </template>
    <template v-if="!$scopedSlots['item'] && $attrs.id" #item="{ item, on, attrs }">
      <v-list-item
        v-bind="attrs"
        v-on="on"
        :id="`${$attrs.id}-item-${item && item.id !== undefined ? item.id : ''}`"
      >
        <v-list-item-content>
          <v-list-item-title>{{ resolveItemText(item) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-if="!$scopedSlots['append'] && $attrs.id" #append>
      <v-icon :id="`${$attrs.id}-dropdown`">$dropdown</v-icon>
    </template>
  </v-autocomplete>
</template>

<script>
import searchQuery from "@/plugins/searchQuery";

export default {
  inheritAttrs: false,
  props: [
    "name",
    "items",
    "loading",
    "disabled",
    "item-text",
    "filter",
    "label",
    "clearable",
    "return-object",
    "dense",
    "cache-items",
    "hide-no-data",
    "solo",
    "autofocus",
    "item-value",
    "value",
    "error-messages",
    "multiple",
    "chips",
    "small-chips",
    "readonly",
    "no-data-text",
    "append-icon",
  ],
  model: {
    prop: "value",
    event: "change",
  },
  data: () => ({
    searchQuery,
  }),
  methods: {
    resolveItemText(item) {
      // Vue 2 normalizes "item-text" → "itemText" (camelCase) in $props
      const itemText = this.itemText || this.$attrs["item-text"];
      if (!item) return "";
      if (!itemText) return typeof item === "string" ? item : "";
      if (typeof itemText === "function") return itemText(item);
      return item[itemText] !== undefined ? String(item[itemText]) : "";
    },
  },
};
</script>

<style></style>
